import { type FormEvent, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '~/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '~/components/ui/card';
import { Input } from '~/components/ui/input';
import { Label } from '~/components/ui/label';

interface LoginFormProps {
    onSubmit: (name: string, password: string) => Promise<void>;
    error?: string | null;
    isLoading?: boolean;
}

export function LoginForm({ onSubmit, error, isLoading }: LoginFormProps) {
    const [name, setName] = useState('');
    const [password, setPassword] = useState('');

    const handleSubmit = async (e: FormEvent) => {
        e.preventDefault();
        await onSubmit(name, password);
    };

    return (
        <Card className="w-full max-w-md">
            <CardHeader className="text-center">
                <CardTitle className="text-2xl">로그인</CardTitle>
            </CardHeader>
            <CardContent>
                <form onSubmit={handleSubmit} className="space-y-4">
                    {error && (
                        <div className="rounded-md border border-destructive/50 bg-destructive/10 p-3 text-sm text-destructive">
                            {error}
                        </div>
                    )}

                    <div className="space-y-2">
                        <Label htmlFor="name">아이디</Label>
                        <Input
                            id="name"
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                            placeholder="아이디를 입력하세요…"
                            autoComplete="username"
                            spellCheck={false}
                        />
                    </div>

                    <div className="space-y-2">
                        <Label htmlFor="password">비밀번호</Label>
                        <Input
                            id="password"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            placeholder="비밀번호를 입력하세요…"
                            autoComplete="current-password"
                        />
                    </div>

                    <Button type="submit" className="w-full" disabled={isLoading}>
                        {isLoading ? '로그인 중...' : '로그인'}
                    </Button>

                    <div className="text-center">
                        <Link
                            to="/reset-password"
                            className="text-sm text-muted-foreground underline hover:text-foreground"
                        >
                            비밀번호를 잊으셨나요?
                        </Link>
                    </div>

                    <Button variant="outline" className="w-full" asChild>
                        <Link to="/signup">아직 계정이 없으신가요?</Link>
                    </Button>

                    <div className="text-center">
                        <Link to="/landing" className="text-sm text-muted-foreground underline hover:text-foreground">
                            서비스가 처음이신가요? 소개 보기
                        </Link>
                    </div>
                </form>
            </CardContent>
        </Card>
    );
}
